<script setup>
import {ref,watchEffect} from 'vue'
import { marked } from 'marked'

// marked 选项
marked.setOptions({
    pedantic: false,
    gfm: true,
    breaks: false,
    sanitize: false,
    smartLists: true,
    smartypants: false,
    xhtml: false,
})

let html = ref(null)

const props = defineProps({
  name:String
})

watchEffect(()=>{
  if(!props.name) return false
  const url = `${getServerAddress()}/markdown/${props.name}.md`

  fetch(url).then(async response=>{
    const data = await response.text()
    html.value = marked(data)
  })
})

function getServerAddress() {
  const url = new URL(window.location.href);
  return `${url.protocol}//${url.hostname}${url.port ? `:${url.port}` : ''}`;
}

</script>

<template>
  <div v-html="html">
   
  </div>
</template>
 
<style scoped>
 
</style>
